module.exports = __webpack_public_path__ + "static/media/placeholder-1.b2ec7984.glb";